export default {
  nav_items: {
    menu: 'Menu',
    locations: 'Locations',
    store_info: 'Store Info',
  },
};
